// extracted by mini-css-extract-plugin
export var activeDot = "_5u-c";
export var buttonContainer = "_5u-9";
export var channelButton = "_5u-a";
export var clickable = "_5u-d";
export var content = "_5u-0";
export var contentFull = "_5u-2";
export var contentThird = "_5u-1";
export var contentWrapper = "_5u-7";
export var description = "_5u-5";
export var heightShort = "_5u-f";
export var image = "_5u-3";
export var imageContainer = "_5u-4";
export var selectButton = "_5u-e";
export var spinnerContainer = "_5u-b";
export var titleContent = "_5u-8";
export var titleWrapper = "_5u-6";